import AutoComplete from './AutoComplete';
export default AutoComplete;


// WEBPACK FOOTER //
// ./~/@tinper/next-ui/lib/wui-autocomplete/src/index.js